import { FC } from 'react'
import { useTranslation } from 'next-i18next/pages'
import { UseFormRegister, UseFormGetValues, FieldErrors } from 'react-hook-form'
import { useRouter } from 'next/router'
import { WishlistManager } from '../../Hooks/WishlistActionTypes'
import { Wishlist, WishlistItemUpdateInput } from '@pylot-data/pylotschema'
import s from '@pagestyles/Wishlist.module.scss'
import styles from './WishlistItems.module.scss'
import useIsMobile from '@lib/hooks/useIsMobile'

export type wishlist = {
    wishlist: Wishlist
    wishlistManager: WishlistManager
    register: UseFormRegister<Array<WishlistItemUpdateInput>>
    getValues?: UseFormGetValues<Array<WishlistItemUpdateInput>>
    errors: FieldErrors<Array<WishlistItemUpdateInput>>
}

type WishlistCardProps = {
    collectionIndex: number
    title: string
    images: string[]
    wishlistId: string
}

const capitalizeFirstLetter = (name?: string) => {
    if (!name) return ''
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
}

const getDimension = (collectionIndex: number, index: number) => {
    const baseStyle = { maxWidth: '100%', margin: 'auto' }

    switch (collectionIndex) {
        case 4:
            return { ...baseStyle, width: '50%', height: '50%' }
        case 2:
            return { ...baseStyle, width: '50%', height: '100%' }
        case 3:
            if (index < 2) {
                return { ...baseStyle, width: '50%' }
            } else {
                return { ...baseStyle, width: '50%' }
            }
        case 1:
            return { ...baseStyle, width: '100%', height: '100%' }
        default:
            return { ...baseStyle, width: '100%', height: 'auto' }
    }
}

export const WishlistCard: FC<WishlistCardProps> = ({
    collectionIndex,
    title,
    images,
    wishlistId
}) => {
    const router = useRouter()
    const isMobile = useIsMobile()

    const handleGoToWishlist = () => {
        router.push(`/account/wishlist/${wishlistId}`)
    }
    return (
        <div
            onClick={() => handleGoToWishlist()}
            className={styles['collection-content']}
            onKeyDown={() => handleGoToWishlist()}
            role="button"
            tabIndex={0}
        >
            <div className={styles['collection']}>
                {images &&
                    images.map((image, index) => (
                        <div
                            className={styles['collection-images']}
                            key={index}
                            style={getDimension(collectionIndex, index)}
                        >
                            <img src={image} alt={`Imagen ${index + 1}`} />
                        </div>
                    ))}
            </div>
            <h5>{capitalizeFirstLetter(title)}</h5>
        </div>
    )
}
